import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormSelectOption } from '../form/types';
import { RelativeTimeForm, TimeDirection, TimeUnit } from './form-relative-time-input.types';

export const TIME_DIRECTION_SELECT_OPTIONS: FormSelectOption<TimeDirection>[] = [
  { label: 'before', value: 'before' },
  { label: 'after', value: 'after' },
];

export const TIME_UNIT_SELECT_OPTIONS: FormSelectOption<TimeUnit>[] = [
  { label: 'hr', value: 'hours' },
  { label: 'min', value: 'minutes' },
];

export const setDefaultRelativeTimeControlValue = () => {
  return new FormGroup<RelativeTimeForm>({
    timeValue: new FormControl(1, [Validators.min(0)]),
    timeUnit: new FormControl('hours'),
    timeDirection: new FormControl('before'),
  });
};
